function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Nieuwe_verloopstaal_87);\n      }\n\n      .st1 {\n        fill: url(#Nieuwe_verloopstaal_84);\n      }\n\n      .st2 {\n        fill: url(#Nieuwe_verloopstaal_82);\n      }\n\n      .st3 {\n        fill: url(#Nieuwe_verloopstaal_88);\n      }\n\n      .st4 {\n        fill: url(#Nieuwe_verloopstaal_8);\n      }\n\n      .st5 {\n        fill: url(#Nieuwe_verloopstaal_81);\n      }\n\n      .st6 {\n        fill: url(#Nieuwe_verloopstaal_83);\n      }\n\n      .st7 {\n        fill: url(#Nieuwe_verloopstaal_85);\n      }\n\n      .st8 {\n        fill: url(#Nieuwe_verloopstaal_86);\n      }\n\n      .st9 {\n        fill: url(#Nieuwe_verloopstaal_89);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_8",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 204.8,
  x2: 804.9,
  y2: 204.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#823beb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ed00b8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_81",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 187.9,
  x2: 804.9,
  y2: 187.9,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_82",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 188,
  x2: 804.9,
  y2: 188,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_83",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 187.8,
  x2: 804.9,
  y2: 187.8,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_84",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 188.2,
  x2: 804.9,
  y2: 188.2,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_85",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 188.2,
  x2: 804.9,
  y2: 188.2,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_86",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 191.8,
  x2: 804.9,
  y2: 191.8,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_87",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 215.6,
  x2: 804.9,
  y2: 215.6,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_88",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 255.9,
  x2: 804.9,
  y2: 255.9,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Nieuwe_verloopstaal_89",
  "data-name": "Nieuwe verloopstaal 8",
  x1: 120.8,
  y1: 237.8,
  x2: 804.9,
  y2: 237.8,
  xlinkHref: "#Nieuwe_verloopstaal_8"
}));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#Nieuwe_verloopstaal_8)",
  points: "741.3 204.2 742.3 205.3 741.3 204.2 741.3 204.2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_81)",
  d: "M208.4,145.9c2.8,0,5.5-.2,8-.7,2.5-.5,4.5-1.9,6.1-4.1,1.6-2.3,2.3-5.9,2.3-11s-.8-9.2-2.3-11.5c-1.6-2.3-3.5-3.6-5.9-4.1-2.4-.5-5-.7-7.9-.7h-80.3c-6.2,0-10.6,1.2-13,3.5-2.4,2.3-3.6,6.6-3.6,12.6v116.2c0,2.7.2,5.3.7,7.9.5,2.5,1.9,4.6,4.1,6.1,2.3,1.5,5.9,2.2,11,2.2h80.7c2.8,0,5.5-.3,8-.7,2.5-.5,4.5-1.9,6.1-4.1,1.6-2.3,2.3-5.9,2.3-11s-.8-9.2-2.3-11.4c-1.6-2.2-3.5-3.6-5.9-4.1-2.4-.6-5-.9-7.9-.9h-64.6v-28.5h43.3c2.8,0,5.4-.2,7.8-.6,2.3-.4,4.1-1.6,5.4-3.6,1.3-2,1.9-5.2,1.9-9.6s-.6-8-1.9-10c-1.3-2-3-3.2-5.2-3.6-2.2-.4-4.7-.6-7.5-.6h-43.7v-27.4h64.3Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_82)",
  d: "M361,116.2c-2.2-1.6-5.9-2.3-11.1-2.3s-8.8.7-11,2.2c-2.3,1.5-3.7,3.4-4.4,5.7-.6,2.3-1,4.8-1,7.3v76.7l-62-85.2c-1.6-2.1-3.3-3.8-5.3-5-2-1.2-5.5-1.8-10.6-1.8s-9,.7-11.4,2.2c-2.3,1.5-3.8,3.4-4.4,5.7-.6,2.3-.9,4.8-.9,7.3v116.6c0,2.8.3,5.5.9,8,.6,2.5,1.9,4.5,4.1,6.1,2.2,1.6,5.8,2.3,10.9,2.3s9-.8,11.3-2.3c2.3-1.6,3.7-3.6,4.2-6.1.6-2.5.9-5.1.9-7.7v-74.8l63.3,85.8c1.6,2,3.4,3.3,5.5,4,2.1.7,5.2,1.1,9.1,1.1s9-.8,11.4-2.3c2.3-1.6,3.8-3.6,4.4-6.1.6-2.5.8-5.1.8-7.7v-115.7c0-2.8-.2-5.5-.7-8-.5-2.5-1.8-4.5-4-6.1Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_83)",
  d: "M494.5,191.9c-2-3.6-4.5-6.8-7.4-9.5,2-2.4,3.6-5,5-7.6,1.3-2.7,2.4-5.6,3.1-8.6.7-3,1-6.1.9-9.2.1-7.8-1.7-15-5.5-21.6-3.8-6.6-9-11.9-15.5-15.9-6.5-4-14-6.1-22.5-6.1h-52.7c-5.2,0-9,.8-11.3,2.4-2.3,1.6-3.7,3.7-4.2,6.2-.6,2.5-.8,5.1-.8,8v115.1c0,2.8.3,5.6.8,8.2.6,2.6,2,4.7,4.2,6.4,2.3,1.6,5.9,2.4,11,2.4h55c6.4,0,12.3-1.2,17.8-3.6,5.5-2.4,10.4-5.7,14.5-9.9,4.2-4.2,7.5-9.1,9.9-14.9,2.4-5.7,3.7-11.9,3.8-18.4,0-4.1-.5-8.1-1.6-12.1-1.1-4-2.6-7.8-4.6-11.4ZM466,223.5c-1.6,2.5-3.6,4.2-6.1,5.1-2.5.9-5,1.4-7.5,1.4h-36.5v-84.5h31.4c6.2,0,10.5,1,13,3.1,2.4,2.1,3.6,5.5,3.6,10.3s-.4,5.1-1.2,6.7c-.8,1.6-1.8,2.8-3,3.5-1.2.7-2.6,1.1-4.1,1.3-1.6.1-3,.2-4.5.2h-6.2c-4.8,0-8.3,1-10.5,3-2.2,2-3.3,5.5-3.3,10.4s1,8.7,3,10.7c2,2.1,5.4,3.1,10.2,3.1h6.2c1.6,0,3.2,0,4.9.2,1.7.1,3.3.4,4.9.8,1.6.4,2.9,1.2,4.1,2.3,1.2,1.1,2.2,2.7,2.9,4.6.7,1.9,1.1,4.4,1.1,7.3,0,4.5-.8,8-2.3,10.5Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_84)",
  d: "M635.4,134.2c-6.7-6.9-14.6-12.4-23.6-16.2-9-3.9-18.7-5.8-29-5.8s-19.3,2-28,5.9c-8.8,4-16.5,9.5-23,16.5-6.6,7-11.8,15.2-15.5,24.5-3.8,9.3-5.6,19.3-5.6,29.9s1.9,20.2,5.7,29.3c3.8,9.1,9.1,17,15.9,23.9,6.8,6.9,14.7,12.2,23.7,16.1,9,3.9,18.6,5.8,28.8,5.8s19.2-1.9,27.9-5.8c8.7-3.9,16.4-9.3,23-16.4,6.7-7,11.9-15.1,15.6-24.3,3.7-9.2,5.6-19,5.6-29.3s-1.9-20.7-5.7-29.9c-3.8-9.2-9.1-17.3-15.8-24.2ZM621.3,205.5c-2.1,5.3-5,9.9-8.7,13.8-3.8,3.9-8.1,7-13.1,9.2-5,2.3-10.3,3.4-15.9,3.4s-10.7-1.1-15.6-3.4c-4.9-2.3-9.2-5.4-13-9.3-3.8-4-6.7-8.6-8.9-13.9-2.2-5.3-3.3-10.9-3.3-16.9s1.1-11.8,3.3-17.1c2.2-5.3,5.2-10,8.9-14,3.7-4,8.1-7.1,13-9.3,4.9-2.2,10.1-3.3,15.6-3.3s10.9,1.1,15.8,3.3c4.9,2.2,9.2,5.3,13,9.3,3.7,4,6.7,8.7,8.8,14,2.1,5.3,3.2,11,3.2,17.1s-1,11.8-3.1,17.1Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_85)",
  d: "M635.4,134.2c-6.7-6.9-14.6-12.4-23.6-16.2-9-3.9-18.7-5.8-29-5.8s-19.3,2-28,5.9c-8.8,4-16.5,9.5-23,16.5-6.6,7-11.8,15.2-15.5,24.5-3.8,9.3-5.6,19.3-5.6,29.9s1.9,20.2,5.7,29.3c3.8,9.1,9.1,17,15.9,23.9,6.8,6.9,14.7,12.2,23.7,16.1,9,3.9,18.6,5.8,28.8,5.8s19.2-1.9,27.9-5.8c8.7-3.9,16.4-9.3,23-16.4,6.7-7,11.9-15.1,15.6-24.3,3.7-9.2,5.6-19,5.6-29.3s-1.9-20.7-5.7-29.9c-3.8-9.2-9.1-17.3-15.8-24.2ZM621.3,205.5c-2.1,5.3-5,9.9-8.7,13.8-3.8,3.9-8.1,7-13.1,9.2-5,2.3-10.3,3.4-15.9,3.4s-10.7-1.1-15.6-3.4c-4.9-2.3-9.2-5.4-13-9.3-3.8-4-6.7-8.6-8.9-13.9-2.2-5.3-3.3-10.9-3.3-16.9s1.1-11.8,3.3-17.1c2.2-5.3,5.2-10,8.9-14,3.7-4,8.1-7.1,13-9.3,4.9-2.2,10.1-3.3,15.6-3.3s10.9,1.1,15.8,3.3c4.9,2.2,9.2,5.3,13,9.3,3.7,4,6.7,8.7,8.8,14,2.1,5.3,3.2,11,3.2,17.1s-1,11.8-3.1,17.1Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Nieuwe_verloopstaal_86)",
  d: "M826.8,241.5l-21.3-16.8c1.2-2.2,2.3-4.6,3.2-7,3.7-9.2,5.6-19,5.6-29.3s-1.9-20.7-5.7-29.9c-3.8-9.2-9.1-17.3-15.8-24.2-6.7-6.9-14.6-12.4-23.6-16.2-9-3.9-18.7-5.8-29-5.8s-19.3,2-28,5.9c-8.8,4-16.5,9.5-23,16.5-6.6,7-11.8,15.2-15.5,24.5-3.8,9.3-5.6,19.3-5.6,29.9s1.9,20.2,5.7,29.3c3.8,9.1,9.1,17,15.9,23.9,6.8,6.9,14.7,12.2,23.7,16.1,9,3.9,18.6,5.8,28.8,5.8s19.2-1.9,27.9-5.8c.2-.1.5-.2.7-.3l-25.3-26.3c-1.4.2-2.9.2-4.4.2-5.5,0-10.7-1.1-15.6-3.4-4.9-2.3-9.2-5.4-13-9.3-3.8-4-6.7-8.6-8.9-13.9-2.2-5.3-3.3-10.9-3.3-16.9s1.1-11.8,3.3-17.1c2.2-5.3,5.2-10,8.9-14,3.7-4,8.1-7.1,13-9.3,4.9-2.2,10.1-3.3,15.6-3.3s10.9,1.1,15.8,3.3c4.9,2.2,9.2,5.3,13,9.3,3.7,4,6.7,8.7,8.8,14,2.1,5.3,3.2,11,3.2,17.1s-.9,10.7-2.5,15.6l-21.9-17.3h0s7.1-7.7,7.1-7.7c1.1-1.2.2-3.4-1.4-4.3-.4-.2-.8-.3-1.2-.3l-9.1-.8h0s-25.8-2.4-25.8-2.4c-2.5-.2-4.3,1.6-3.8,4.1l5.1,28.2h0s1.1,6.3,1.1,6.3c0,.4.2.8.4,1.2,1,1.5,3.3,2.2,4.4,1l7-7.7h0s1,1.1,1,1.1l19.5,20.6,22.6,23.8,11.7,12.3,7.5,7.9c3.6,2.4,8.6,2,11.7-1.4l12.7-13.9c3.6-3.9,3-10-1.2-13.2Z"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#Nieuwe_verloopstaal_87)",
  points: "742.3 205.3 745.9 209.1 761.9 225.9 761.9 225.9 742.3 205.3"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#Nieuwe_verloopstaal_88)",
  points: "784.5 249.8 796.2 262.1 784.5 249.8 784.5 249.8"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#Nieuwe_verloopstaal_89)",
  points: "761.9 225.9 784.5 249.8 784.5 249.8 761.9 225.9 761.9 225.9"
});

function SvgEnboqLogoNoPayoffSvg(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 942.4 377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnboqLogoNoPayoffSvg);
export default __webpack_public_path__ + "static/media/Enboq-Logo-NoPayoff-Svg.6ace169a4eab7e3af0120d16a5e16b1f.svg";
export { ForwardRef as ReactComponent };